(function () {
  function initSection(container) {
    var buttons = container.querySelectorAll('.ss-tabs-button');
    var answers = container.querySelectorAll('.ss-tabs-answer');
    var icons = container.querySelectorAll('.ss-tabs-chevron');

    function openAnswer(index) {
      answers[index].classList.add('ss-tabs-answer--open');
      icons[index].style.setProperty('--rotate', '180deg');
    }
    function closeAnswer(index) {
      answers[index].classList.remove('ss-tabs-answer--open');
      icons[index].style.setProperty('--rotate', '0deg');
    }
    function toggleAnswer(index) {
      if (!answers[index].classList.contains('ss-tabs-answer--open')) {
        openAnswer(index);
      } else {
        closeAnswer(index);
      }
    }
    function closeAllAnswerBut(index) {
      answers.forEach(function (answer, i) {
        if (i !== index) closeAnswer(i);
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        toggleAnswer(index);
        closeAllAnswerBut(index);
      });
    });
  }

  // Initialize all ss-tabs sections on the page
  document.querySelectorAll('.ss-tabs-grid').forEach(function (grid) {
    var section = grid.closest('.shopify-section');
    if (section && !section.dataset.ssTabsInit) {
      section.dataset.ssTabsInit = 'true';
      initSection(section);
    }
  });

  // Re-initialize when the Shopify editor reloads a section
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('.ss-tabs-grid')) {
        initSection(event.target);
      }
    });
  }
})();

